module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_error_remoteEntry_mjs_16017a9d__;